module.exports = __webpack_public_path__ + "static/img/微信图片_20220709152337.1fd57d31.png";